import { SHA256, enc } from "crypto-js";
import { decodeJWT } from "./jwt";

export const encryptLayerSHA256 = (value?: string): string => {
  if (value) {
    const hash = SHA256(value.toLowerCase());
    const encryptString = hash.toString(enc.Hex);
    return encryptString;
  }
  return "";
};

export interface UserJWTInterface {
  exp: number;
  iat: number;
  jti: string;
  iss: string;
  sub: string;
  typ: string;
  azp: string;
  session_state: string;
  acr: string;
  scope: string;
  sid: string;
  email_verified: boolean;
  name: string;
  preferred_username: string;
  locale: string;
  given_name: string;
  uuid: string;
  family_name: string;
  email: string;
}

export interface EncryptProfileInterface {
  em: string;
  ph: string;
  fn: string;
  ln: string;
  db: string;
  ge: string;
  ct: string;
  st: string;
  country: string;
  userId: string;
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
  bornDate: string;
  gender: string;
  city: string;
  state: string;
  subscriptionType: string;
  plan: string;
}

export const fetchProfile = (
  accessToken: string,
  subscription_type: string
): EncryptProfileInterface => {
  const profile: UserJWTInterface = decodeJWT(accessToken);
  const name = profile?.name || "";
  const nameList = name.split(" ");
  const firstName = nameList[0] || "";
  const lastName = nameList[nameList.length - 1] || "";
  const encrypt: EncryptProfileInterface = {
    em: encryptLayerSHA256(profile.email),
    ph: encryptLayerSHA256(""),
    fn: encryptLayerSHA256(firstName),
    ln: encryptLayerSHA256(lastName),
    db: encryptLayerSHA256(""),
    ge: encryptLayerSHA256(""),
    ct: encryptLayerSHA256(""),
    st: encryptLayerSHA256(""),
    country: encryptLayerSHA256(""),
    userId: profile?.uuid,
    email: profile?.email,
    phone: "",
    firstName: firstName,
    lastName: lastName,
    bornDate: "",
    gender: "",
    city: "",
    state: "",
    subscriptionType: subscription_type ?? "",
    plan: "",
  };
  return encrypt;
};
